import * as React from "react";
import type { SVGProps } from "react";
const ExplainIcon = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em" fill="none" style={{
  userSelect: "none",
  flexShrink: 0
}} {...props}><path fill="currentColor" fillRule="evenodd" d="M5 5.25a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h2a.75.75 0 0 0 0-1.5H5.75V6.75H7a.75.75 0 0 0 0-1.5zm14 0a.75.75 0 0 1 .75.75v12a.75.75 0 0 1-.75.75h-2a.75.75 0 0 1 0-1.5h1.25V6.75H17a.75.75 0 0 1 0-1.5z" clipRule="evenodd" /></svg>;
export default ExplainIcon;